export const DrawQcFieldName = 'drawQcFieldComponent';
